import { Component, Input } from '@angular/core';

@Component({
    selector: 'interaction',
    template: require('./interaction.component.html')
})
export class InteractionComponent {
    @Input() interaction: PgRendererDto.InteractionDefinition;
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/interaction.component.ts